module.exports = __webpack_public_path__ + "img/sign-pad-bg-en.8a0239c2.png";